export const NO_CLASS_ROOM_ERROR_MESSAGE = 'You need to provide the space';
export const NO_POST_ID_MESSAGE = 'You need to provide the post id';
